import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user/user.service';
import { DataSharingService } from '../../../auth/data-sharing.service';




@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isUserLoggedIn: boolean;
  ImageBool:boolean=true;
  currentUserData: any;
  currentUserRole: any;
  surveyURlBool:Boolean=true;
  isUserAdmin: boolean;
  isUserVendor: boolean;
  isUserSiteinc: boolean;
  isUserPurchase: boolean;
  isUserFinance: boolean;
  isUserTransport: boolean;
  roleId: number;
  createProject: boolean;
  assignSurveyLink: boolean;
  assignVendorClip: boolean;
  vendorRegistration: boolean;
  respondentData: boolean;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService) {
    debugger;
    this.createProject= false;
    this.assignSurveyLink= false;;
    this.assignVendorClip= false;;
    this.vendorRegistration= false;;
    this.respondentData= false;;
    this.dataSharingService.isUserLoggedIn.subscribe(
      value => {
        this.isUserLoggedIn = value;
      });
    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserFinance.subscribe(
      value => {
        this.isUserFinance = value;
      });
    this.userService.isUserPurchase.subscribe(
      value => {
        this.isUserPurchase = value;
      }
    );
    this.userService.isUserSiteinc.subscribe(
      value => {
        this.isUserSiteinc = value;
      }
    );
    this.userService.isUserTransport.subscribe(
      value => {
        this.isUserTransport = value;
      }
    );


  }

  ngOnInit() {
    //code for getting current user data
    debugger;
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
      }
    );

    var surveyURl =  window.location.href;
    if(surveyURl.includes("StartSurvey"))
    {
      this.surveyURlBool = false;
      //this.ImageBool = false;
    }
    else{
      this.surveyURlBool = true;
      this.ImageBool = true;
    }



  }


  ngAfterViewInit() {
    document.getElementById("toogleRight").style.visibility = "hidden";
  }

  toggleLeftSide() {
    //alert("hello");
    //document.getElementById("leftsidebar").style.display = "none";
    document.getElementById("leftsidebar").style.visibility = "hidden";
    document.getElementById("page-wrapper").style.paddingLeft = "0px";
    document.getElementById("toogleRight").style.visibility = "visible";
    document.getElementById("toogleLeft").style.visibility = "hidden";

  }

  toggleRightSidebar() {
    //alert("hello");
    //document.getElementById("leftsidebar").style.display = "none";
    document.getElementById("leftsidebar").style.visibility = "visible";
    document.getElementById("page-wrapper").style.paddingLeft = "225px";
    document.getElementById("toogleLeft").style.visibility = "visible";
    document.getElementById("toogleRight").style.visibility = "hidden";
  }

  Logout() {
    //localStorage.removeItem("userToken");
    this.userService.purgeAuth();
    this.router.navigate(['/home']);
  }

}
